import { isAllowedToTransformEvents, isAllowedToDeliverEvents } from '@ion/api';

export default function isAllowedToTestPipeline() {
  const canTransformEvent = isAllowedToTransformEvents();
  const canDeliverEvent = isAllowedToDeliverEvents();

  return canTransformEvent && canDeliverEvent;
}
